import { render, staticRenderFns } from "./jskstj.vue?vue&type=template&id=22babb56&scoped=true"
import script from "./jskstj.vue?vue&type=script&lang=js"
export * from "./jskstj.vue?vue&type=script&lang=js"
import style0 from "./jskstj.vue?vue&type=style&index=0&id=22babb56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22babb56",
  null
  
)

export default component.exports